import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, OnDestroy, QueryList, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FolderTreeStateService, } from '@components/ui-folder-tree/ui-folder-tree-state';
import { FolderType, } from '@models';
import { Subject, } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, switchMap, take, takeUntil, tap, } from 'rxjs/operators';
var UiFolderTreeComponent = /** @class */ (function () {
    function UiFolderTreeComponent(_cd) {
        this._cd = _cd;
        this.searchItemSize = 60;
        this.highlightedFolder = new EventEmitter();
        this.selectedFolder = new EventEmitter();
        this.FolderType = FolderType;
        this.searchControl = new FormControl('');
        this._destroyed$ = new Subject();
        this.trackById = function (_, folder) {
            return folder.folderData ? folder.folderData.id : folder.fakeId;
        };
    }
    Object.defineProperty(UiFolderTreeComponent.prototype, "isFolderLoading", {
        get: function () {
            return this.state && this.state.loadingFolder$.value.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiFolderTreeComponent.prototype, "highlighted", {
        get: function () {
            return this.state.highlighted$.value;
        },
        enumerable: true,
        configurable: true
    });
    UiFolderTreeComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.state.highlighted$.pipe(takeUntil(this._destroyed$)).subscribe(function (f) { return _this.highlightedFolder.next(f); });
        if (
        // we have folders loaded
        this.state.treeContainers.length ||
            // we don't have folders and there's nothing selected
            this.state.selectedFolderId == null) {
            this.state.refresh();
        }
        // rendered virtual scroller instance
        this.vs$ = this._virtualScroller.changes.pipe(filter(function (changes) { return !!_this.state.treeContainers.length && !!changes.first; }), take(1), switchMap(function (_a) {
            var vs = _a.first;
            return vs.scrolledIndexChange.pipe(take(1), tap(function () { return _this._cd.detectChanges(); }), map(function () { return vs; }));
        }));
        this.vs$.pipe(tap(function (vs) { return vs.scrollToIndex(_this.state.activeIndex); }), switchMap(function (vs) { return vs.scrolledIndexChange; }), takeUntil(this._destroyed$)).subscribe(function (index) { return _this.state.activeIndex = index; });
        this.searchControl.valueChanges.pipe(debounceTime(250), distinctUntilChanged(), takeUntil(this._destroyed$)).subscribe(function (val) {
            _this.state.searchValue = val;
        });
        this._virtualScroller.changes.pipe(tap(function (_a) {
            var vs = _a.first;
            return _this.vs = vs;
        }), takeUntil(this._destroyed$)).subscribe();
    };
    UiFolderTreeComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    UiFolderTreeComponent.prototype.selectFolder = function (folder) {
        if (!folder) {
            return;
        }
        if (this.context === 'manage') {
            this.state.highlighted$.next(folder);
            return;
        }
        if (!folder.isSelectable) {
            return;
        }
        this.state.highlighted$.next(folder);
        this.selectedFolder.emit(folder);
    };
    UiFolderTreeComponent.prototype.onSearchClearClicked = function () {
        this.searchControl.setValue('');
        this.search.nativeElement.focus();
        this.state.searchValue = '';
    };
    UiFolderTreeComponent.prototype.navigate = function (key) {
        var _a = key.toLowerCase().split('arrow'), arrow = _a[0], direction = _a[1];
        if (arrow === '') {
            this.state.navigate(direction, this.vs);
        }
    };
    return UiFolderTreeComponent;
}());
export { UiFolderTreeComponent };
